import React, { useState } from 'react';
import styles from './Referral.module.css';
import useWalletStore from '../../providers/walletStore';

const Referral = () => {
  const [copied, setCopied] = useState(false);
  const { wallet } = useWalletStore();

  const generateReferralLink = () => {
    if (!wallet?.address) return '';
    const refCode = wallet.address.slice(0, 8);
    return `${window.location.origin}/?ref=${refCode}`;
  };

  const handleCopy = async () => {
    const referralLink = generateReferralLink();
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className={styles.referralSection}>
      <h2>Refer Friends</h2>
      <div className={styles.referralCard}>
        <p className={styles.referralInfo}>
          Share your referral link with friends and earn points when they join!
        </p>
        <div className={styles.referralLinkBox}>
          <input 
            type="text" 
            readOnly 
            value={generateReferralLink()}
            className={styles.referralInput}
          />
          <button 
            className={`${styles.copyButton} ${copied ? styles.copied : ''}`}
            onClick={handleCopy}
            disabled={!wallet?.address}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
        {!wallet?.address && (
          <p className={styles.warning}>Please connect your wallet to get a referral link.</p>
        )}
      </div>
      <div className={styles.referralStats}>
        <div className={styles.referralStat}>
          <h3>Total Referrals</h3>
          <p>0</p>
        </div>
        <div className={styles.referralStat}>
          <h3>Points Earned</h3>
          <p>0</p>
        </div>
      </div>
    </div>
  );
};

export default Referral;
